import { useAtom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'
import { StorageKeys } from '~/atoms/StorageKeys'

interface MessageDrafts {
  [threadId: number]: string | undefined
}

const draftsAtom = atomWithStorage(
  StorageKeys.MessageDrafts,
  {} as MessageDrafts,
)

export const useMessageDraft = (threadId: number) => {
  const [drafts, setDrafts] = useAtom(draftsAtom)

  const draft = drafts[threadId]
  const setDraft = (newDraft?: string) => {
    setDrafts({
      ...drafts,
      [threadId]: newDraft,
    })
  }

  return [draft, setDraft] as const
}
